import { render, staticRenderFns } from "./RecommendQuotationRightBar.vue?vue&type=template&id=9b39a270&scoped=true&"
import script from "./RecommendQuotationRightBar.vue?vue&type=script&lang=js&"
export * from "./RecommendQuotationRightBar.vue?vue&type=script&lang=js&"
import style0 from "./RecommendQuotationRightBar.vue?vue&type=style&index=0&id=9b39a270&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b39a270",
  null
  
)

export default component.exports